// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__29seO","inner":"Form_inner__3R_ih","range":"Form_range__3e20I","name":"Form_name__2keYQ","actions":"Form_actions__3nCKe"};